export default __webpack_public_path__ + "static/media/tttalpha.8c369784.jpg";